import DataGrid, {
  Column,
  Paging,
  FilterRow,
  Export,
  Summary,
  GroupItem,
} from "devextreme-react/data-grid";
import { useFetch } from "src/hooks/useFetch";
import { SpatialRun } from "../types";
import { Typography } from "@mui/material";

interface UnassignedSequence {
  batch: string;
  sequence: string;
  occurrenceRate: number;
}

interface CytoCellUnassignedSequencesTableProps {
  run: SpatialRun;
}

const CytoUnassignedSequencesTable = ({
  run,
}: CytoCellUnassignedSequencesTableProps) => {
  const {
    data: rawData,
    isLoading,
    isError,
    error,
  } = useFetch(
    `/spatialRun/${run?.runID}/barcodeUnassignedSequences`,
    !!run?.runID
  );

  const tableData = rawData as UnassignedSequence[] | undefined;

  if (isLoading) {
    return <Typography>Loading unassigned sequences...</Typography>;
  }

  if (isError) {
    return (
      <Typography color="error">
        Error loading unassigned sequences: {String(error)}
      </Typography>
    );
  }

  if (!tableData || tableData.length === 0) {
    return <Typography>No unassigned sequences data available</Typography>;
  }

  return (
    <div style={{ marginTop: "40px" }}>
      <Typography variant="h6" style={{ marginBottom: "20px" }}>
        Unassigned Barcode Sequences
      </Typography>
      <DataGrid
        dataSource={tableData}
        showBorders={true}
        rowAlternationEnabled={true}
        columnAutoWidth={true}
      >
        <FilterRow visible={true} />
        <Paging defaultPageSize={20} />
        <Export enabled={true} />
        <Column dataField="batch" caption="Batch" groupIndex={0} />
        <Column dataField="sequence" caption="Sequence" />
        <Column
          dataField="occurrenceRate"
          caption="Occurrence Rate"
          dataType="number"
          format={{ type: "percent", precision: 2 }}
          sortOrder="desc"
        />
        <Summary>
          <GroupItem
            column="occurrenceRate"
            summaryType="sum"
            displayFormat="Total: {0}"
            valueFormat={{ type: "percent", precision: 2 }}
          />
        </Summary>
      </DataGrid>
    </div>
  );
};

export default CytoUnassignedSequencesTable;
